import { STSClient as E, GetFederationTokenCommand as P } from "@aws-sdk/client-sts";
import { S3Client as x, PutObjectCommand as j } from "@aws-sdk/client-s3";
import { getSignedUrl as I } from "@aws-sdk/s3-request-presigner";
import { v4 as T } from "uuid";
var v = function() {
  return v = Object.assign || function(o) {
    for (var t, c = 1, a = arguments.length; c < a; c++) {
      t = arguments[c];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (o[e] = t[e]);
    }
    return o;
  }, v.apply(this, arguments);
};
function J(n, o) {
  var t = {};
  for (var c in n)
    Object.prototype.hasOwnProperty.call(n, c) && o.indexOf(c) < 0 && (t[c] = n[c]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, c = Object.getOwnPropertySymbols(n); a < c.length; a++)
      o.indexOf(c[a]) < 0 && Object.prototype.propertyIsEnumerable.call(n, c[a]) && (t[c[a]] = n[c[a]]);
  return t;
}
function U(n, o, t, c) {
  function a(e) {
    return e instanceof t ? e : new t(function(s) {
      s(e);
    });
  }
  return new (t || (t = Promise))(function(e, s) {
    function l(i) {
      try {
        r(c.next(i));
      } catch (y) {
        s(y);
      }
    }
    function u(i) {
      try {
        r(c.throw(i));
      } catch (y) {
        s(y);
      }
    }
    function r(i) {
      i.done ? e(i.value) : a(i.value).then(l, u);
    }
    r((c = c.apply(n, o || [])).next());
  });
}
function D(n, o) {
  var t = { label: 0, sent: function() {
    if (e[0] & 1)
      throw e[1];
    return e[1];
  }, trys: [], ops: [] }, c, a, e, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(r) {
    return function(i) {
      return u([r, i]);
    };
  }
  function u(r) {
    if (c)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, r[0] && (t = 0)), t; )
      try {
        if (c = 1, a && (e = r[0] & 2 ? a.return : r[0] ? a.throw || ((e = a.return) && e.call(a), 0) : a.next) && !(e = e.call(a, r[1])).done)
          return e;
        switch (a = 0, e && (r = [r[0] & 2, e.value]), r[0]) {
          case 0:
          case 1:
            e = r;
            break;
          case 4:
            return t.label++, { value: r[1], done: !1 };
          case 5:
            t.label++, a = r[1], r = [0];
            continue;
          case 7:
            r = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (e = t.trys, !(e = e.length > 0 && e[e.length - 1]) && (r[0] === 6 || r[0] === 2)) {
              t = 0;
              continue;
            }
            if (r[0] === 3 && (!e || r[1] > e[0] && r[1] < e[3])) {
              t.label = r[1];
              break;
            }
            if (r[0] === 6 && t.label < e[1]) {
              t.label = e[1], e = r;
              break;
            }
            if (e && t.label < e[2]) {
              t.label = e[2], t.ops.push(r);
              break;
            }
            e[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        r = o.call(n, t);
      } catch (i) {
        r = [6, i], a = 0;
      } finally {
        c = e = 0;
      }
    if (r[0] & 5)
      throw r[1];
    return { value: r[0] ? r[1] : void 0, done: !0 };
  }
}
function M(n, o, t) {
  if (t || arguments.length === 2)
    for (var c = 0, a = o.length, e; c < a; c++)
      (e || !(c in o)) && (e || (e = Array.prototype.slice.call(o, 0, c)), e[c] = o[c]);
  return n.concat(e || Array.prototype.slice.call(o));
}
function k(n) {
  var o, t, c, a;
  return {
    accessKeyId: (o = n == null ? void 0 : n.accessKeyId) !== null && o !== void 0 ? o : "".concat(process.env.S3_UPLOAD_KEY),
    secretAccessKey: (t = n == null ? void 0 : n.secretAccessKey) !== null && t !== void 0 ? t : "".concat(process.env.S3_UPLOAD_SECRET),
    bucket: (c = n == null ? void 0 : n.bucket) !== null && c !== void 0 ? c : "".concat(process.env.S3_UPLOAD_BUCKET),
    region: (a = n == null ? void 0 : n.region) !== null && a !== void 0 ? a : "".concat(process.env.S3_UPLOAD_REGION),
    endpoint: n == null ? void 0 : n.endpoint,
    forcePathStyle: n == null ? void 0 : n.forcePathStyle
  };
}
function N(n) {
  var o = k(n), t = new x(v(v({ credentials: {
    accessKeyId: o.accessKeyId,
    secretAccessKey: o.secretAccessKey
  }, region: o.region }, o.forcePathStyle ? { forcePathStyle: o.forcePathStyle } : {}), o.endpoint ? { endpoint: o.endpoint } : {}));
  return t;
}
var R = function() {
  return T();
}, L = /[^0-9a-zA-Z!_\\.\\*'\\(\\)\\\-/]/g, q = function(n) {
  return n.replace(L, " ").replace(/\s+/g, "-");
};
function V(n) {
  var o, t = n.request, c = n.options;
  return U(this, void 0, void 0, function() {
    var a, e, s, l, u, r, i, y, f, p, b, h, S, m, w, _, g, A, O, K;
    return D(this, function(d) {
      switch (d.label) {
        case 0:
          if (a = k(c), e = G(a), e.length > 0)
            throw new Error("Next S3 Upload: Missing ENVs ".concat(e.join(", ")));
          return t.json ? [4, t.json()] : [3, 2];
        case 1:
          return l = d.sent(), [3, 3];
        case 2:
          l = t.body, d.label = 3;
        case 3:
          return s = l, u = s.filename, c.key ? [4, Promise.resolve(c.key(t, u))] : [3, 5];
        case 4:
          return i = d.sent(), [3, 6];
        case 5:
          i = "next-s3-uploads/".concat(R(), "/").concat(q(u)), d.label = 6;
        case 6:
          return r = i, y = (o = s._nextS3) === null || o === void 0 ? void 0 : o.strategy, f = a.bucket, p = a.region, b = a.endpoint, y !== "presigned" ? [3, 8] : (h = s.filetype, S = N(a), m = {
            Bucket: f,
            Key: r,
            ContentType: h,
            CacheControl: "max-age=630720000"
          }, [4, I(S, new j(m), {
            expiresIn: 60 * 60
          })]);
        case 7:
          return w = d.sent(), [2, {
            key: r,
            bucket: f,
            region: p,
            endpoint: b,
            url: w
          }];
        case 8:
          return _ = {
            credentials: {
              accessKeyId: a.accessKeyId,
              secretAccessKey: a.secretAccessKey
            },
            region: p
          }, g = {
            Statement: [
              {
                Sid: "Stmt1S3UploadAssets",
                Effect: "Allow",
                Action: ["s3:PutObject"],
                Resource: ["arn:aws:s3:::".concat(f, "/").concat(r)]
              }
            ]
          }, A = new E(_), O = new P({
            Name: "S3UploadWebToken",
            Policy: JSON.stringify(g),
            DurationSeconds: 60 * 60
            // 1 hour
          }), [4, A.send(O)];
        case 9:
          return K = d.sent(), [2, {
            token: K,
            key: r,
            bucket: f,
            region: p
          }];
      }
    });
  });
}
var G = function(n) {
  var o = ["accessKeyId", "secretAccessKey", "bucket", "region"];
  return o.filter(function(t) {
    return !n[t] || n.key === "";
  });
};
export {
  U as _,
  D as a,
  J as b,
  v as c,
  M as d,
  N as e,
  k as g,
  V as h,
  q as s,
  R as u
};
